import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { Tenant } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

interface GetTenantsResponse {
  success: boolean;
  tenants: Tenant[];
}

const getTenants: QueryFunction<
  GetTenantsResponse,
  ['/shared/tenants', undefined]
> = async () => {
  if (isMockServices()) return await mock(_mockData);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetTenantsResponse>('/shared/tenants', {
    method: 'GET',
  });
  if (response.data) return response.data;
  throw new Error('Failed to fetch tenants');
};

export default getTenants;

const _mockData: GetTenantsResponse = {
  success: true,
  tenants: [
    {
      id: 'cm8nm5bke0000o10i7d0y6zbh',
      createdAt: '2025-03-24T22:03:10.669Z',
      name: 'razvan',
      schema: 'tenant_schema_cnyddd08bcab20n8ug3fmzfo',
      status: 'TODO',
      updatedAt: '2025-03-24T22:03:10.669Z',
      configuration: {
        magicLinkAuth: {
          enabled: false,
        },
      },
    },
  ],
};
